import { render, staticRenderFns } from "./inOrOutWarehouseForm.vue?vue&type=template&id=5353d1f0&scoped=true&"
import script from "./inOrOutWarehouseForm.vue?vue&type=script&lang=js&"
export * from "./inOrOutWarehouseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5353d1f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5353d1f0')) {
      api.createRecord('5353d1f0', component.options)
    } else {
      api.reload('5353d1f0', component.options)
    }
    module.hot.accept("./inOrOutWarehouseForm.vue?vue&type=template&id=5353d1f0&scoped=true&", function () {
      api.rerender('5353d1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Warehouse/components/warehouseHome/inOrOutWarehouseForm.vue"
export default component.exports